import { atom } from 'recoil';

export const cartState = atom({
  key: 'cartState',
  default: {
    items: [],
    total: 0,
    count: 0,
    isOpen: false
  },
});